import React from 'react'
import { Clock, ClipboardList, Star, Users } from 'lucide-react'
import useAsset from '../../hooks/useAsset'

const QRPage: React.FC = () => {
  const faviconPattern = useAsset('/favicon.png')
  const logo = useAsset('/tailtations.svg')
  const qrCode = useAsset('/secret-qr.svg')

  return (
    <div className="min-h-screen-safe bg-gray-200 flex items-start justify-center py-8">
      {/* 4x6 inch card (384px x 576px at 96 DPI) */}
      <div
        className="bg-white shadow-2xl overflow-hidden relative"
        style={{
          width: '384px',
          height: '576px',
          maxWidth: '384px',
          maxHeight: '576px'
        }}
      >
        {/* Header with Logo and Lobster Pattern */}
        <div className="relative bg-gray-50 flex items-center justify-center overflow-hidden" style={{ height: '120px', paddingTop: '20px', paddingBottom: '20px' }}>
          {/* Lobster pattern background using favicon.png */}
          <div
            className="absolute inset-0 opacity-[0.08]"
            style={{
              backgroundImage: `url(${faviconPattern})`,
              backgroundSize: '63px 63px',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center'
            }}
          />

          {/* Logo */}
          <div className="relative z-10">
            <img
              src={logo}
              alt="Tailtations"
              style={{ height: '80px', width: 'auto' }}
            />
          </div>
        </div>

        {/* Main Content */}
        <div className="px-8 pt-3 pb-[165px] text-center space-y-2.5">
          {/* Headline */}
          <h1 className="text-[32px] font-black leading-[1.1] tracking-tight" style={{ fontFamily: 'League Spartan, sans-serif' }}>
            Be the First to Know.<br />Skip the Line
          </h1>

          {/* Subheading */}
          <p className="text-base font-bold" style={{ color: '#962831' }}>
            Join the exclusive SECRET program
          </p>

          {/* QR Code Section */}
          <div className="py-2">
            <p className="text-lg font-bold mb-2" style={{ color: '#962831', letterSpacing: '0.5px' }}>
              SCAN TO JOIN
            </p>

            {/* QR Code with Border */}
            <div className="inline-flex items-center justify-center rounded-lg" style={{ border: '4px solid #962831' }}>
              <img
                src={qrCode}
                alt="QR Code"
                style={{ width: '150px', height: '150px', display: 'block' }}
              />
            </div>
          </div>
        </div>

        {/* Bottom Icons Section */}
        <div className="absolute bottom-0 left-0 right-0 bg-white px-6 pb-4 pt-3">
          <div className="grid grid-cols-4 gap-3">
            <div className="flex flex-col items-center">
              <div className="w-11 h-11 rounded-full flex items-center justify-center mb-1.5" style={{ backgroundColor: '#962831' }}>
                <Clock className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <p className="text-[10px] font-bold text-center leading-tight">
                Early Event<br />Alerts
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-11 h-11 rounded-full flex items-center justify-center mb-1.5" style={{ backgroundColor: '#962831' }}>
                <ClipboardList className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <p className="text-[10px] font-bold text-center leading-tight">
                Pre-Order<br />Access
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-11 h-11 rounded-full flex items-center justify-center mb-1.5" style={{ backgroundColor: '#962831' }}>
                <Star className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <p className="text-[10px] font-bold text-center leading-tight">
                Skip the<br />Line
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-11 h-11 rounded-full flex items-center justify-center mb-1.5" style={{ backgroundColor: '#962831' }}>
                <Users className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <p className="text-[10px] font-bold text-center leading-tight">
                Exclusive<br />Perks
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="text-center mt-2.5">
            <p className="text-xs font-bold">
              https://secret.tailtations.com
            </p>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style>{`
        @media print {
          body {
            margin: 0;
            padding: 0;
          }

          .min-h-screen-safe {
            min-height: 0;
            background: white;
            padding: 0;
            display: block;
          }

          @page {
            size: 4in 6in;
            margin: 0;
          }
        }
      `}</style>
    </div>
  )
}

export default QRPage
